<template>
  <font-awesome-icon
    icon="clipboard-list"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClipboardList } from '@fortawesome/free-solid-svg-icons'

library.add(faClipboardList)

export default {
  name: 'CoozzyClipBoardIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
